import { FC } from "react";
import { Box, Table, Thead, Tr, Th, Text, Tbody } from "@chakra-ui/react";

export const TableHead: FC<{
  children: React.ReactNode;
  column: {
    id: number;
    label: string;
  }[];
  isPage?: boolean;
}> = ({ children, column, isPage }) => (
  <Box w="100%" marginTop={isPage ? "30px" : "0"}>
    <Table variant="simple">
      <Thead borderBottom="2px solid #A6A8AE">
        <Tr>
          {column.map(({ id, label }) => (
            <Th key={id}>
              <Text fontSize="10px" color="#A6A8AE">
                {label}
              </Text>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>{children}</Tbody>
    </Table>
  </Box>
);
